import { Component } from "react"

/* Components */
import { Pagination, Tag } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { history } from "../../api/Manager"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"
import { CloseIcon, UsersIcon } from "./ManagerIcons"


/* Fields */
const PERCENTAGE = 95 / 5


/* Widget Manager History */
class ManagerHistory extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            id: 0,
            name: "",
            status: "loading",
            data: [],
            count: 0,
            page: 1,
        }
    }

    /* Open Action */
    open = ({ id, name }) => {

        this.setState({
            visible: true,
            id: utils.checkValue(id, 0),
            name: utils.checkValue(name, ""),
            status: "loading",
            data: [],
            count: 0,
            page: 1,
        }, () => {
            this.load(1)
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, id: 0, name: "", status: "loading", data: [], count: 0, page: 1 })
    }

    /* Load Action */
    load = (page = 1) => {

        /* Fields */
        const { id } = this.state

        /* Set Page */
        this.setState({ page, status: "loading" })

        /* Send to REST API */
        history({ id, page }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "error", data: [], count: 0 })
        })

    }

    /* Draw Device */
    _device = (json) => {

        try {

            /* Parse Device */
            const list = Object.entries(JSON.parse(json))

            /* Check List */
            if (list.length === 0) {
                return null
            }

            return (
                <div>
                    {list.map((item, index) => {

                        /* Check Value */
                        if (!item[0] || !item[1]) {
                            return null
                        }

                        return (
                            <div className="manager--json-row" key={`${index}`}>
                                <div className="manager--json-key">{item[0]}</div>
                                <div className="manager--json-value">{item[1]}</div>
                            </div>
                        )
                    })}
                </div>
            )
        }
        catch {
            return null
        }
    }

    /* Draw Time */
    _time = (time) => {

        /* Fields */
        const datetime = utils.getTime(time)

        return (
            <div>
                <div className="manager--list-time">{datetime.time}</div>
                <div className="manager--list-date">{datetime.date}</div>
            </div>
        )
    }

    /* Draw Body */
    _body = () => {

        /* Fields */
        const { status, data, count, page } = this.state

        /* Check Status */
        if (status === "loading") {
            return <div className="manager--modal-loading"><LoadingOutlined /></div>
        }

        /* Check Error */
        if (status !== "ok") {
            return <div className="manager--empty"><UsersIcon /><span>{t("swal.generic")}</span></div>
        }

        /* Check Data */
        if (data.length === 0) {
            return <div className="manager--empty"><UsersIcon /><span>{t("manager.noHistory")}</span></div>
        }

        return (
            <div className="manager--modal-body flush">

                <div className="manager--list-header">
                    <div className="number">#</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.device")}</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.browser")}</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.ip")}</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.country")}</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.lastActivity")}</div>
                </div>

                {data.map((item, index) =>
                    <div className="manager--list-row" key={`${index}`}>

                        <div className="manager--list-column number">{(page - 1) * 10 + index + 1}</div>

                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>
                            <Tag color={item.type === "mobile" ? "green" : "purple"}>{utils.checkValue(item.type, "-")}</Tag>
                            {this._device(item.device)}
                        </div>

                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>{utils.checkValue(item.browser, "-")}</div>
                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>{utils.checkValue(item.ip, "-")}</div>
                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>{utils.checkValue(item.country, "-")} {utils.checkValue(item.city, "")}</div>
                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>{this._time(item.updatedAt)}</div>

                    </div>
                )}

                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.load(page)} />

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, name } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="manager--modal wide"
                overlayClassName="manager--overlay"
                closeTimeoutMS={200}
            >

                <div className="manager--modal-header">

                    <div>
                        <h2>{t("manager.historyTitle")}</h2>
                        <p>{name}</p>
                    </div>

                    <div onClick={() => this.close()} className="manager--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                {/* Draw Body */}
                {this._body()}

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(ManagerHistory)
